import { RightArrowIcon, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import type { Department } from '../types';

export interface CareersListDepartmentProps extends Department {
  readonly index: number;
  readonly onClick: (department: string) => void;
}

interface ContentProps {
  readonly count: number;
  readonly name: string;
}

const DesktopContent = ({ count, name }: ContentProps) => {
  const t = useTranslations();
  return (
    <div className="hidden items-center justify-between md:flex">
      <TypographyV3
        className="text-[1.375rem] lg:text-heading-lg"
        weight="light"
      >
        {name}
      </TypographyV3>
      <div className="items-center md:flex md:gap-x-48 xl:gap-x-96">
        <TypographyV3 variant="body-small" className="mt-2">
          {count} {t('open_roles')}
        </TypographyV3>
        <RightArrowIcon />
      </div>
    </div>
  );
};

const MobileContent = ({ count, name }: ContentProps) => {
  const t = useTranslations();
  return (
    <div className="flex items-center justify-between md:hidden">
      <div>
        <TypographyV3
          className="text-[1.375rem] lg:text-heading-lg"
          weight="light"
        >
          {name}
        </TypographyV3>
        <TypographyV3 variant="body-small" className="mt-2">
          {count} {t('open_roles')}
        </TypographyV3>
      </div>
      <RightArrowIcon />
    </div>
  );
};

const CareersListDepartment = ({
  count,
  index,
  name,
  onClick,
}: CareersListDepartmentProps) => {
  const handleClick = () => {
    onClick(name);
  };

  return (
    <button
      className="relative block w-full border-x-0 border-solid border-transparent py-6 text-left text-sandstone-500"
      data-cy={`department-item-${index}`}
      key={`dept-${index}`}
      onClick={handleClick}
    >
      <DesktopContent name={name} count={count} />
      <MobileContent name={name} count={count} />
    </button>
  );
};

export default CareersListDepartment;
